import { createFileRoute } from "@tanstack/react-router";
import { validateSpecsSearch } from "../features/specs/search";
import { SpecsPage } from "../features/specs/specs-page";

export const Route = createFileRoute("/_app/w/$workspace/specs")({
  validateSearch: validateSpecsSearch,
  component: SpecsPage,
});
